<template>
  <div>
    <the-header ref="header"></the-header>
    <breadcrumb></breadcrumb>
    <div class="flex">
      <the-sidebar></the-sidebar>
      <div class="page-main-content page-main-content-map max-width-1148 flex-auto min-width-1000">
        <div>
          <router-view :key="fullPath"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TheHeader from '@/member/components/common/TheHeader'
import TheSidebar from '@/member/components/common/TheSidebar'
import Breadcrumb from '@/member/components/common/Breadcrumb'

export default {
  name: 'MapLayout',
  components: { TheHeader, TheSidebar, Breadcrumb },
  computed: {
    ...mapGetters(['isCallingApi', 'isLoadingFullPage']),
    fullPath() {
      return this.$route.fullPath
    },
  },
}
</script>

<style scoped>
.page-main-content-map {
  width: 100%;
}
.max-width-1148 {
  max-width: 100% !important;
}
</style>
